export const BUTTON_SIZES = ['small', 'medium', 'large'];
export const BUTTON_VARIANTS = ['default', 'outline', 'flat', 'text'];
export const BUTTON_COLORS = ['primary', 'secondary', 'white'];
export const DEFAULT_BUTTON_SIZE = 'medium';
export const DEFAULT_BUTTON_VARIANT = 'default';
export const DEFAULT_BUTTON_COLOR = 'primary';